import React, { useState } from 'react';
import Form from 'react-bootstrap/Form';
import { MenuItem, Select, FormControl, InputLabel, Chip } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { FaAngleDown } from "react-icons/fa6";


const useStyles = makeStyles({
    chip: {
        marginTop: '4px !important',
        padding: '2px, 8px, 2px, 8px',
        fontFamily: 'Inter !important',
        fontSize: '14px',
        lineHeight: '22px',
        fontWeight: '500 !important',
        textAlign: 'center',
    },

    selectRoot: {
        '& .MuiOutlinedInput-root': {
            '&:hover .MuiOutlinedInput-notchedOutline': {
                borderColor: "#099250",
            },
            '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                borderWidth: '1px',
                borderColor: "#099250",
                boxShadow: '0px 0px 0px 4px #D3F8DF',
            },
            '& .MuiSelect-icon': {
                marginRight: '6px',
                marginTop: '-2px',
                width: '20px',
                height: '20px',
            },
            fontFamily: 'Inter',
            fontSize: '14px',
            lineHeight: '22px',
            fontWeight: '500',
        },
    },
});

function TableCustomFilters({
    handleFilterSelect,
    selectedFilterValue,
    roles = [],
    loading= false
}) {
    const [status, setRole] = useState('');
    const classes = useStyles();

    const handleChange = (event) => {
        setRole(event.target.value);
        handleFilterSelect(event.target.value);
    };

    const getRoleColor = (roleName) => {
        switch (roleName) {
            case 'Lawyer':
                return { backgroundColor: "#ECFDF3", color: "#6941C6" };
            case 'Tradesman':
                return { backgroundColor: "#EFF8FF", color: "#175CD3" };
            case 'Admin':
                return { backgroundColor: "#FEF3F2", color: "#B42318" };
            default:
                return { backgroundColor: "#F2F4F7", color: "#344054" };
        }
    };

    return (
        <>
            <Form className='d-flex align-items-center filter-gap'>
                <FormControl
                    variant="outlined"
                    className={classes.selectRoot}
                >
                    <InputLabel
                        sx={{
                            marginTop: '-8px',
                        }}
                        shrink={false}
                    >
                        {selectedFilterValue ? '' : 'Role'}
                    </InputLabel>
                    <Select
                        IconComponent={FaAngleDown}
                        value={selectedFilterValue}
                        noValidate={false}
                        onChange={handleChange}
                        disabled={loading}
                        sx={{
                            borderRadius: '8px',
                            border: '1px solid #EAECF0',
                            width: "140px",
                            padding: "10px 0px",
                            height: "36px",
                            '&:hover': {
                                borderColor: '#099250',
                            },
                        }}
                        MenuProps={{
                            PaperProps: {
                                sx: {
                                    borderRadius: '8px',
                                    boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.1)',
                                    '& .MuiMenuItem-root': {
                                        padding: '0 8px',
                                    },
                                    '& .MuiMenuItem-root.Mui-selected': {
                                        backgroundColor: '#FFFFFF',
                                    },
                                    '& .MuiMenuItem-root:hover': {
                                        backgroundColor: '#FFFFFF !important',
                                    },
                                },
                            },
                        }
                        }
                    >
                        <MenuItem value="" className={classes.chip}>
                            <Chip label="All" size="small" style={{ backgroundColor: "#F9FAFB", color: "#344054", fontFamily: "Inter", fontWeight: "400" }} />
                        </MenuItem>
                        {roles.map((role) => (
                            <MenuItem key={role.id} value={role.id} className={classes.chip}>
                                <Chip
                                    label={role.role_name}
                                    size="small"
                                    style={{
                                        ...getRoleColor(role.role_name),
                                        fontFamily: "Inter",
                                        fontWeight: "400"
                                    }}
                                />
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
            </Form >
        </>
    );
}

export default TableCustomFilters;

